import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Grid,
  TextField,
  makeStyles,
  ClickAwayListener,
  Tooltip,
  Typography,
  InputBase,
  InputAdornment,
  IconButton,
  Switch,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import AddIcon from "@material-ui/icons/Add";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import DeleteIcon from "@material-ui/icons/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import * as miscAction from "../../../actions/miscAction";
import * as modelAction from "../../../actions/modelAction";
import DMDeleteDialog from "./DMDeleteDialog";
import CustomButton from "./CustomButton";
import { uuidv4 } from "../../../utilities/applicationutils";
import * as _ from "lodash";
import EditIcon from "@material-ui/icons/Edit";
import {
  getPreSignedUrl,
  uploadNewJSONToS3,
  getJsonFilesForModels,
  getPreSignedUrlToDownload,
  clearCacheAfterFileUpload,
  sampleJsonPreSignedUrlToDownload,
} from "../../../services/GetPreSignedUrl";
import SearchableList from "./SearchableList";
import {
  copySequenceInModel,
  createUpdateModelBlockConfig,
  getModelBlockConfig,
} from "../../../services/ModelsService";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";
import AntSwitch from "./AntSwitch";

const windowHeight = window.innerHeight;

const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
    width={20}
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    />
  </svg>
);

const CopyModelDropDown = ({
  CopySequenceDataToModel,
  modelOptions = [],
  title = "",
}) => {
  return (
    <div>
      {/* <Typography
        style={{ lineHeight: "30px", fontSize: "12px", fontWeight: "400" }}
      >
        Copy from another Model
      </Typography> */}
      <div>
        <SearchableList
          title={title}
          onSelectAction={CopySequenceDataToModel}
          options={modelOptions}
        />{" "}
      </div>
      {/* <div>
        <div style={{background: "#D1E9FD"}}>CopyModelDropDown</div>
      </div> */}
    </div>
  );
};

const EditUploadTextField = ({
  value = "",
  setFile = (e) => {},
  heading = "",
  canDownload = false,
  modelId = "",
  expectedFileName = "",
  setSnackBar = null,
  sampleFile = null,
}) => {
  const fileInputRef = useRef(null);
  const [fileError, setFileError] = useState("");

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      var fileExtension = file.name.split(".").pop().toLowerCase();
      const fileValid = expectedFileName.split(".")[0].toLowerCase();
      console.log(fileValid);

      if (fileExtension !== "json") {
        setFileError("Only .json file are allowed.");
        setFile(null);
      } else if (!file.name.toLowerCase().includes(fileValid)) {
        setFileError(`File name should be ${expectedFileName} only.`);
        setFile(null);
      } else {
        setFileError("");
        let dumpFile = new File([file], expectedFileName, { type: file.type });
        setFile(dumpFile);
      }
    }
  };

  const downFun = (url, fileName = "downloadedJson.json") => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        setSnackBar(
          true,
          "success",
          `${fileName} file downloaded successfully`
        );
      })
      .catch((error) => {
        setSnackBar(true, "error", `Error fetching and downloading the file`);
        console.error("Error fetching and downloading the file:", error);
      });
  };

  const fileDownloadCall = async () => {
    await getPreSignedUrlToDownload(modelId, value)
      .then((response) => {
        let preSignedUrl = response.data.preSignedUrl;
        window.stopLoading();
        downFun(preSignedUrl, value);
      })
      .catch((error) => {
        window.stopLoading();
      });
  };

  const fileSampleJsonDownloadCall = async (file, type) => {
    await sampleJsonPreSignedUrlToDownload(file, type)
      .then((response) => {
        let preSignedUrl = response.data.preSignedUrl;
        window.stopLoading();
        downFun(preSignedUrl, file);
      })
      .catch((error) => {
        window.stopLoading();
      });
  };

  const downloadFile = async () => {
    if (canDownload) {
      window.startLoading();
      await fileDownloadCall();
    }
  };

  return (
    <div>
      {heading && (
        <div style={{ fontSize: "14px", marginBottom: "5px" }}>{heading}</div>
      )}
      <div
        style={{
          border: "1px solid #BAC0D0",
          height: "38px",
          fontSize: "14px",
          fontWeight: "700",
          color: "#1891F6",
          borderRadius: "4px",
          padding: "0px 12px 0px 12px",
          display: "flex",
          marginRight: "10px",
          lineHeight: "38px",
        }}
        // value={value}
      >
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <Tooltip title={value} arrow>
            <span>{value}</span>
          </Tooltip>
        </div>
        <IconButton
          style={{
            width: "20px",
            height: "20px",
            margin: "auto",
            marginRight: "5px",
          }}
        >
          <span
            style={{
              width: "20px",
              cursor: "pointer",
              background: "#E5E7ED",
              height: "25px",
              width: "35px",
              padding: "0px 2px",
              borderRadius: "3px",
            }}
          >
            <EditIcon
              style={{ width: "20px", color: "black" }}
              onClick={handleIconClick}
            />
          </span>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept=".json"
            multiple={false}
          ></input>
        </IconButton>
        <IconButton
          style={{ width: "20px", height: "20px", margin: "auto" }}
          disabled={!canDownload}
        >
          <span
            style={{
              width: "20px",
              cursor: "pointer",
              background: "#E5E7ED",
              height: "25px",
              width: "35px",
              padding: "0px 2px",
              borderRadius: "3px",
              color: "black",
            }}
            onClick={downloadFile}
          >
            {downloadIcon}
          </span>
        </IconButton>
      </div>
      {sampleFile && (
        <div
          style={{
            color: "#1891F6",
            fontSize: "12px",
            cursor: "pointer",
            width: "fit-content",
          }}
          onClick={() => {
            fileSampleJsonDownloadCall(
              expectedFileName,
              expectedFileName.includes("bynder") ? "bynder" : expectedFileName.includes("bim") ? "bim" : "bimsmith"
            );
          }}
        >
          <u>Sample JSON</u>
        </div>
      )}
      {fileError && (
        <div style={{ color: "red", fontSize: "14px" }}>{fileError}</div>
      )}
    </div>
  );
};

const SwitchButton = ({ label, value, setSwitchData, valueKey }) => {
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <Typography
        style={{
          fontSize: "14px",
          fontWeight: "600",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        {label || ""}
      </Typography>
      <div style={{ marginTop: "13px" }}>
        <AntSwitch
          checked={value[valueKey]}
          onChange={() => {
            setSwitchData({
              ...value,
              [valueKey]: !value[valueKey],
            });
          }}
        />
      </div>
    </div>
  );
};

const AddDynamicFields = ({
  title,
  subTitle,
  repText,
  modelId,
  modelState,
  miscState,
  onshowEdit,
  getModels,
  deleteRepText,
  createRepText,
  updateRepText,
  setSnackBar,
  onCloseSelected,
  sortUpdate,
  update,
  isUnsaveChanges,
  setIsUnsaveChanges,
  modelData = [],
  intl,
}) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
      padding: "16px",
      marginTop: "56px",
      // height:`${windowHeight*0.6}px`,
      width: "98%",
    },
    gridField: {
      marginBottom: "8px",
    },
    deleteBtn: {
      cursor: "pointer",
    },
    twoColumnLayout: {
      display: "flex",
      gap: "20px",
      width: "100%",
    },
    leftColumn: {
      flex: "0 0 40%",
      minWidth: "0",
      maxHeight: "calc(100vh - 150px)",
      overflowY: "auto",
    },
    rightColumn: {
      flex: "0 0 60%",
      minWidth: "0",
      maxHeight: "calc(100vh - 150px)",
      overflowY: "auto",
    },
    fileUploadSection: {
      border: "1px solid #E5E7ED",
      borderRadius: "8px",
      padding: "16px",
      backgroundColor: "#FAFBFC",
    },
    blockInfoSection: {
      border: "1px solid #E5E7ED",
      borderRadius: "8px",
      padding: "16px",
      backgroundColor: "#FAFBFC",
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 183px)",
    },
    blockInfoContent: {
      flex: "1",
      overflow: "auto",
      marginBottom: "20px",
    },
    blockInfoFooter: {
      marginTop: "auto",
      paddingTop: "10px",
      borderTop: "1px solid #E5E7ED",
    },
  }));
  const [models, setModels] = useState([]);

  const classes = useStyles();
  const dragRef = useRef();
  const [isDrag, setIsDrag] = useState(false);
  const [isDisable, setDisable] = useState(false);
  const [oldFields, setOldFields] = useState(repText);
  const [fields, setFields] = useState([]);
  const [deleteArr, setDeleteArr] = useState([]);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
  const [file1Name, setFile1Name] = useState("");
  const [file2Name, setFile2Name] = useState("");
  const [file3Name, setFile3Name] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  // const [repText, setRepText] = useState([]);
  const [modelTitle, setModelTitle] = useState("");

  const [bimsmithRule, setbimsmithRule] = useState(null);
  const [bimsmithOverlap, setbimsmithOverlap] = useState(null);
  const [bynderRule, setbynderRule] = useState("");
  const [bynderOverlap, setbynderOverlap] = useState("");
  const [bimsmithRuleName, setbimsmithRuleName] = useState("");
  const [bimsmithOverlapName, setbimsmithOverlapName] = useState("");
  const [bynderRuleName, setbynderRuleName] = useState("");
  const [bynderOverlapName, setbynderOverlapName] = useState("");
  const [bimRule, setbimRule] = useState(null);
  const [bimOverlap, setbimOverlap] = useState(null);
  const [bimRuleName, setbimRuleName] = useState("");
  const [bimOverlapName, setbimOverlapName] = useState("");
  const [bimPropertyName,setBimPropertyName] = useState("");
  const [bimPropertyMap, setBimPropertyMap] = useState(null)

  const [switchData, setSwitchData] = useState({
    bynderStatus: false,
    bimsimthStatus: false,
    bimStatus: false,
    configureDrawingStatus: false,
    requestRevitFilesStatus: false,
  });

  const fileNames = [
    "OverlapDependency.json",
    "RuleMapper.json",
    "WB_Info.json",
    "RuleMapper_bynder.json",
    "OverlapDependency_bynder.json",
    "RuleMapper_bimsimth.json",
    "OverlapDependency_bimsimth.json",
    "RuleMapper_bim.json",
    "OverlapDependency_bim.json",
    "PropertyMapping_bim.json",
  ];

  // let fileNames = [
  //   `${modelId}_overlap_dependency.json`,
  //   `${modelId}_rules_mapper.json`,
  //   `${modelId}_web_info.json`,
  // ];

  useEffect(() => {
    // fetchModel();
    setModels(modelData || modelState?.models?.data);
    let models = modelData || modelState?.models?.data;

    getModelOption(models);

    fetchJsonFile();
    getModelConfig();
  }, [modelData]);

  useEffect(() => {
    if (repText === undefined || repText?.length === 0) {
      setFields([
        { id: fields.length, description: "", ddName: "", dxfName: "" },
      ]);
    }
  }, [repText]);

  const getModelConfig = async () => {
    await getModelBlockConfig(modelId)
      .then((res) => {
        const {
          bimsimthStatus = false,
          bynderStatus = false,
          bimStatus = false,
          configureDrawingStatus = false,
          requestRevitFilesStatus = false,
        } = res?.data || {};
        setSwitchData({
          bimsimthStatus,
          bynderStatus,
          bimStatus,
          configureDrawingStatus,
          requestRevitFilesStatus,
        });
      })
      .catch((err) => {
        console.log(err);
        updateModelConfig();
      });
  };

  const updateModelConfig = async (isCreate = true) => {
    const {
      bimsimthStatus = false,
      bynderStatus = false,
      bimStatus = false,
      configureDrawingStatus = false,
      requestRevitFilesStatus = false,
    } = switchData || {};

    const payload = {
      modelId: modelId,
      bynderStatus: bynderStatus,
      bimsimthStatus: bimsimthStatus,
      bimStatus: bimStatus,
      configureDrawingStatus: configureDrawingStatus,
      requestRevitFilesStatus: requestRevitFilesStatus,
    };

    await createUpdateModelBlockConfig(isCreate ? "" : modelId, payload)
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setFields(repText);
  }, [repText]);

  const repTextValue = (model) => {
    const newm = model?.replaceableText;
    const filterData = newm.slice().sort((a, b) => a.sort - b.sort) || [];
    return filterData;
  };

  const fetchJsonFile = async () => {
    await getJsonFilesForModels(modelId)
      .then((res) => {
        res.data.forEach((ele) => {
          if ([fileNames[0]].includes(ele)) {
            setFile1Name(ele);
          } else if ([fileNames[1]].includes(ele)) {
            setFile2Name(ele);
          } else if ([fileNames[2]].includes(ele)) {
            setFile3Name(ele);
          } else if ([fileNames[3]].includes(ele)) {
            setbynderRuleName(ele);
          } else if ([fileNames[4]].includes(ele)) {
            setbynderOverlapName(ele);
          } else if ([fileNames[5]].includes(ele)) {
            setbimsmithRuleName(ele);
          } else if ([fileNames[6]].includes(ele)) {
            setbimsmithOverlapName(ele);
          } else if ([fileNames[7]].includes(ele)) {
            setbimRuleName(ele);
          } else if ([fileNames[8]].includes(ele)) {
            setbimOverlapName(ele);
          } else if ([fileNames[9]].includes(ele)) {
            setBimPropertyName(ele);
          }
        });
      })
      .catch((err) => {
        console.log("Fetch JSON file Error: ", err);
      });
  };

  const getModelOption = (data) => {
    let t = [];
    data.forEach((ele) => {
      if (ele.modelId !== modelId) {
        let d = ele.modelName.split("-");
        t.push({ label: d[0], secondaryLabel: d[1], value: ele.modelId });
      }
    });
    // console.log(t);
    setModelOptions(t);
  };

  const fetchModel = () => {
    getModels().then(() => {
      setModels(modelData || modelState?.models?.data);
      let models = modelData || modelState?.models?.data;

      getModelOption(models);

      let latestModel = models.find((obj) => obj.modelId === modelId);
      const filterData =
        latestModel?.replaceableText.slice().sort((a, b) => a.sort - b.sort) ||
        [];

      setFields(filterData);
      window.stopLoading();
      setDisable(false);
    });
  };

  const clearChacheAfterJsonUpload = async () => {
    await clearCacheAfterFileUpload()
      .then((res) => {
        // success
      })
      .catch((err) => {
        console.log("clear cache error: ", err);
      });
  };

  useEffect(() => {
    if (repText === undefined || repText?.length === 0) {
      setFields([
        { id: fields.length, description: "", ddName: "", dxfName: "" },
      ]);
    }
  }, [repText]);

  useEffect(() => {
    setFields(repText);
  }, [repText]);

  const handleNewField = () => {
    const idText = "dep";
    const depId = idText.concat(uuidv4());
    setFields([
      ...fields,
      {
        id: depId,
        description: "",
        ddName: "",
        dxfName: "",
        sort: fields.length + 1,
      },
    ]);

    if (!isUnsaveChanges) setIsUnsaveChanges(true);
  };

  const areAnyFilesNotNull = () => {
    return (
      file1 !== null ||
      file2 !== null ||
      file3 !== null ||
      bynderRule ||
      bynderOverlap ||
      bimsmithRule ||
      bimsmithOverlap ||
      bimRule ||
      bimOverlap || 
      bimPropertyMap
    );
  };

  const handleFieldChange = (index, fieldName) => (event) => {
    const newFields = [...fields];
    newFields[index][fieldName] = event.target.value;
    setFields(newFields);
    if (!isUnsaveChanges) setIsUnsaveChanges(true);
  };

  const handleDeleteField = (item) => {
    const newFields = fields.filter((field) => field.id != item.id);
    const isEmpty = item?.id.includes("dep");
    if (!isEmpty) {
      deleteArr.push(item);
      setDeleteArr(deleteArr);
    }

    setFields(newFields);
    if (!isUnsaveChanges) setIsUnsaveChanges(true);
  };

  const reorderFunc = (arr, removeIndex, addIndex) => {
    if (!arr) return;
    const [reorderedFields] = arr.splice(removeIndex, 1);
    arr.splice(addIndex, 0, reorderedFields);
    return arr;
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return; // Ignore drop outside droppable container
    const oldFields = [...fields];
    const updatedFields = reorderFunc(
      oldFields,
      droppedItem.source.index,
      droppedItem.destination.index
    );
    setIsDrag(true);
    setFields(updatedFields);
    if (!isUnsaveChanges) setIsUnsaveChanges(true);
  };

  const handleClickAway = async (event) => {};

  const handleFileUpload = () => {
    let files = [
      file1,
      file2,
      file3,
      bynderRule,
      bynderOverlap,
      bimsmithRule,
      bimsmithOverlap,
      bimRule,
      bimOverlap,
      bimPropertyMap
    ];

    let promises = [];

    const dumyFiles = [];
    files.forEach((f, i) => {
      if (f) {
        dumyFiles.push({ file: f, index: i });
      }
    });

    console.log(dumyFiles);

    dumyFiles.map(async (data, i) => {
      const { file, index } = data;
      if (file !== null) {
        promises.push(index);
        await getPreSignedUrl(modelId, fileNames[index]).then(
          async (response) => {
            let preSignedUrl = response.data.preSignedUrl;

            await uploadNewJSONToS3(preSignedUrl, file)
              .then((res) => {
                if (i === dumyFiles.length - 1) {
                  clearChacheAfterJsonUpload();
                }
              })
              .catch((err) => {
                console.log("clear cache error: ", err);
              });
            // let newPromise = uploadNewJSONToS3(preSignedUrl, file);
            // promises.push(newPromise);
          }
        );
      }
    });

    if (promises.length > 0) {
      // this code was all commented
      Promise.all(promises)
        .then((response) => {
          // console.log("uploaded", response);
        })
        .catch((error) => {
          window.stopLoading();
          setSnackBar(
            true,
            "error",
            injectIntlTranslation(
              intl,
              "uploadFileError",
              constants.uploadFileError
            )
          );
        });
    }
  };

  /* Save API call */
  const onSave = async (payload = null) => {
    try {
      const difference = _.differenceWith(fields, oldFields, _.isEqual);

      if (fields.length > 0) {
        fields.forEach(async (newItem, index) => {
          newItem.sort = index;
        });
      }
      if (deleteArr.length > 0) {
        deleteArr.forEach(async (item) => {
          await deleteRepText({ replaceableTextId: item?.id });
        });
      }

      if (areAnyFilesNotNull()) {
        handleFileUpload();
      }

      updateModelConfig(false);

      if (fields.length > 0) {
        fields.forEach(async (newItem) => {
          const isEmpty = newItem?.id.includes("dep");

          if (isEmpty) {
            await createRepText({
              modelId: modelId,
              ddName: newItem?.ddName,
              dxfName: newItem?.dxfName,
              description: newItem?.description,
              sort: newItem.sort,
            });
          }
        });
      }
      if (difference.length > 0) {
        difference.forEach(async (newItem) => {
          const isEmpty = newItem?.id.includes("dep");
          if (!isEmpty) {
            await updateRepText({
              replaceableTextId: newItem?.id,
              modelId: modelId,
              ddName: newItem?.ddName,
              dxfName: newItem?.dxfName,
              description: newItem?.description,
              sort: newItem.sort,
            });
          }
        });
      }
      if (isDrag) {
        sortUpdate(fields);
        setIsDrag(false);
      }
      setDeleteArr([]);
      onshowEdit();
      setSnackBar(
        true,
        "success",
        injectIntlTranslation(
          intl,
          "changesSaveSuccess",
          constants.changesSaveSuccess
        )
      );

      if (payload?.sourceModelId) {
        CopySequenceModelAPICall(payload);
      } else {
        onCloseSelected({
          id: uuidv4(),
          isClosed: true,
        });
      }
      setIsUnsaveChanges(false);
      setDisable(true);
      fetchModel();
      update(fields);
    } catch (error) {
      console.log(error);
      onshowEdit();
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "replacebleTextSaveError",
          constants.replacebleTextSaveError
        )
      );
    }
  };

  const CopySequenceDataToModel = (selectedModel) => {
    let payload = {
      sourceModelId: selectedModel.value,
      destinationModelId: modelId,
    };
    if (isUnsaveChanges) {
      setUnsaveChangePopup(payload);
      // onSave(payload);
    } else {
      CopySequenceModelAPICall(payload);
    }
  };

  const CopySequenceModelAPICall = async (payload) => {
    window.startLoading();
    await copySequenceInModel(payload)
      .then((res) => {
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(
            intl,
            "blockInformationCopySuccess",
            constants.blockInformationCopySuccess
          )
        );
        window.copyOptionDropClose();
        setUnsaveChangePopup(false);
        setDisable(false);
        fetchModel();
      })
      .catch((err) => {
        console.log(err);
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(
            intl,
            "blockInformationCopyError",
            constants.blockInformationCopyError
          )
        );
        window.stopLoading();
      })
      .finally(() => {
        // window.stopLoading();
        setIsUnsaveChanges(false);
      });
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={classes.paper}
        style={{ width: "1068px", paddingTop: "15px", height: "calc(100vh - 87px)" }}
        ref={dragRef}
      >
        <div>
          <h2
            id="simple-modal-title"
            style={{ marginTop: "0px", marginBottom: "0px" }}
          >{`${title || "-"}`}</h2>
          <p
            id="simple-modal-sub-title"
            style={{ color: "#617080", marginTop: "5px", marginBottom: "20px" }}
          >
            {subTitle}
          </p>
        </div>

        {/* Two Column Layout */}
        <div className={classes.twoColumnLayout}>
          {/* Left Column - File Upload Section */}
          <div className={classes.leftColumn}>
            <div className={classes.fileUploadSection}>
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  marginBottom: "15px",
                  color: "#2C3E50",
                }}
              >
                Map ECAT to Drawing Manager
              </Typography>

              {/* 1st json row */}
              <div style={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={file1 ? file1.name : file1Name || "-"}
                      setFile={(f) => {
                        setFile1(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "Overlap dependency",
                        "Overlap dependency"
                      )}
                      canDownload={!!file1Name}
                      modelId={modelId}
                      expectedFileName={fileNames[0]}
                      setSnackBar={setSnackBar}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={file2 ? file2.name : file2Name || "-"}
                      setFile={(f) => {
                        setFile2(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "Rules Mapper",
                        "Rules Mapper"
                      )}
                      canDownload={!!file2Name}
                      modelId={modelId}
                      expectedFileName={fileNames[1]}
                      setSnackBar={setSnackBar}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={file3 ? file3.name : file3Name || "-"}
                      setFile={(f) => {
                        setFile3(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(intl, "WB_Info", "WB_Info")}
                      canDownload={!!file3Name}
                      modelId={modelId}
                      expectedFileName={fileNames[2]}
                      setSnackBar={setSnackBar}
                    />
                  </Grid>
                </Grid>
                <SwitchButton
                  label={"BIM Integration and its mapping"}
                  value={switchData}
                  setSwitchData={setSwitchData}
                  valueKey={"bimStatus"}
                />
              </div>

              {/* 2nd json row */}
              <div style={{ marginBottom: "20px" }}>
              <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bimOverlap
                          ? bimOverlap.name
                          : bimOverlapName || "-"
                      }
                      setFile={(f) => {
                        setbimOverlap(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "BIM Overlap dependency",
                        "BIM Overlap dependency"
                      )}
                      canDownload={!!bimOverlapName}
                      modelId={modelId}
                      expectedFileName={fileNames[8]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bimRule ? bimRule.name : bimRuleName || "-"
                      }
                      setFile={(f) => {
                        setbimRule(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "BIM Rules Mapper",
                        "BIM Rules Mapper"
                      )}
                      canDownload={!!bimRuleName}
                      modelId={modelId}
                      expectedFileName={fileNames[7]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bimPropertyMap ? bimPropertyMap.name : bimPropertyName || "-"
                      }
                      setFile={(f) => {
                        setBimPropertyMap(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "Bim Property Mapper",
                        "Bim Property Mapper"
                      )}
                      canDownload={!!bimPropertyName}
                      modelId={modelId}
                      expectedFileName={fileNames[9]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                </Grid>
                {/*  */}

                <SwitchButton
                  label={"BimSmith Integration and its mapping"}
                  value={switchData}
                  setSwitchData={setSwitchData}
                  valueKey={"bimsimthStatus"}
                />
              </div>

              {/* 3rd json row */}
              <div style={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bimsmithOverlap
                          ? bimsmithOverlap.name
                          : bimsmithOverlapName || "-"
                      }
                      setFile={(f) => {
                        setbimsmithOverlap(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "BimSmith Overlap dependency",
                        "BimSmith Overlap dependency"
                      )}
                      canDownload={!!bimsmithOverlapName}
                      modelId={modelId}
                      expectedFileName={fileNames[6]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bimsmithRule ? bimsmithRule.name : bimsmithRuleName || "-"
                      }
                      setFile={(f) => {
                        setbimsmithRule(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "BimSmith Rules Mapper",
                        "BimSmith Rules Mapper"
                      )}
                      canDownload={!!bimsmithRuleName}
                      modelId={modelId}
                      expectedFileName={fileNames[5]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                </Grid>

                <SwitchButton
                  label={"Bynder Integration and its mapping"}
                  value={switchData}
                  setSwitchData={setSwitchData}
                  valueKey={"bynderStatus"}
                />
              </div>

              {/* 4th json row */}
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={
                        bynderOverlap
                          ? bynderOverlap.name
                          : bynderOverlapName || "-"
                      }
                      setFile={(f) => {
                        setbynderOverlap(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "Bynder Overlap dependency",
                        "Bynder Overlap dependency"
                      )}
                      canDownload={!!bynderOverlapName}
                      modelId={modelId}
                      expectedFileName={fileNames[4]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <EditUploadTextField
                      value={bynderRule ? bynderRule.name : bynderRuleName || "-"}
                      setFile={(f) => {
                        setbynderRule(f);
                        if (!isUnsaveChanges) setIsUnsaveChanges(true);
                      }}
                      heading={injectIntlTranslation(
                        intl,
                        "Bynder Rules Mapper",
                        "Bynder Rules Mapper"
                      )}
                      canDownload={!!bynderRuleName}
                      modelId={modelId}
                      expectedFileName={fileNames[3]}
                      setSnackBar={setSnackBar}
                      sampleFile={"demo"}
                    />
                  </Grid>
                </Grid>

                <SwitchButton
                  label={"Configure drawings in drawing manager"}
                  value={switchData}
                  setSwitchData={setSwitchData}
                  valueKey={"configureDrawingStatus"}
                />
                <SwitchButton
                  label={"Configure request revit files"}
                  value={switchData}
                  setSwitchData={setSwitchData}
                  valueKey={"requestRevitFilesStatus"}
                />
              </div>
            </div>
          </div>

          {/* Right Column - Block Information Section */}
          <div className={classes.rightColumn}>
            <div className={classes.blockInfoSection}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#2C3E50",
                  }}
                >
                  {injectIntlTranslation(
                    intl,
                    "blockInformationLabel",
                    constants.blockInformationLabel
                  )}
                </Typography>
                {modelOptions.length && (
                  <CopyModelDropDown
                    CopySequenceDataToModel={CopySequenceDataToModel}
                    modelOptions={modelOptions}
                    isUnsaveChanges={isUnsaveChanges}
                    title={injectIntlTranslation(
                      intl,
                      "Copy from another model",
                      "Copy from another model"
                    )}
                  />
                )}
              </div>
              
              {/* Scrollable Content Area */}
              <div className={classes.blockInfoContent}>
                <div style={{ paddingTop: "10px", width: "100%" }}>
                  <DragDropContext onDragEnd={handleDrop}>
                    <Droppable droppableId="fields-array">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          {fields.map((field, index) => {
                            return (
                              <Draggable
                                key={field.id}
                                draggableId={`${field.id}`}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <Grid
                                      item
                                      className={classes.gridField}
                                      key={field.id}
                                      xs={12}
                                      justify="center"
                                      container
                                      spacing={1}
                                      alignItems="center"
                                      innerRef={provided.innerRef}
                                      style={{ marginTop: "5px" }}
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        style={{ display: "flex" }}
                                      >
                                        <DragIndicatorIcon
                                          style={{
                                            marginBottom: "0px",
                                            padding: "6px",
                                          }}
                                          color="disabled"
                                          fontSize="small"
                                        />
                                        <Tooltip
                                          title={injectIntlTranslation(
                                            intl,
                                            field.description,
                                            field.description
                                          )}
                                          arrow
                                        >
                                          <TextField
                                            size="small"
                                            id="outlined-basic"
                                            placeholder={injectIntlTranslation(
                                              intl,
                                              "infoLabelField",
                                              constants.infoLabelField
                                            )}
                                            label={injectIntlTranslation(
                                              intl,
                                              "infoLabelField",
                                              constants.infoLabelField
                                            )}
                                            variant="outlined"
                                            value={injectIntlTranslation(
                                              intl,
                                              field.description,
                                              field.description
                                            )}
                                            onChange={handleFieldChange(
                                              index,
                                              "description"
                                            )}
                                            InputProps={{
                                              style: { fontWeight: 700 },
                                            }}
                                            style={{ width: "100%" }}
                                          />
                                        </Tooltip>
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <Tooltip
                                          title={injectIntlTranslation(
                                            intl,
                                            field.ddName,
                                            field.ddName
                                          )}
                                          arrow
                                        >
                                          <TextField
                                            size="small"
                                            id="outlined-basic"
                                            placeholder={injectIntlTranslation(
                                              intl,
                                              "ddNameField",
                                              constants.ddNameField
                                            )}
                                            label={injectIntlTranslation(
                                              intl,
                                              "ddNameField",
                                              constants.ddNameField
                                            )}
                                            variant="outlined"
                                            value={injectIntlTranslation(
                                              intl,
                                              field.ddName,
                                              field.ddName
                                            )}
                                            onChange={handleFieldChange(
                                              index,
                                              "ddName"
                                            )}
                                            style={{ width: "100%" }}
                                            InputProps={{
                                              style: { fontWeight: 700 },
                                            }}
                                          />
                                        </Tooltip>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        style={{ display: "flex" }}
                                      >
                                        <Tooltip
                                          title={injectIntlTranslation(
                                            intl,
                                            field.dxfName,
                                            field.dxfName
                                          )}
                                          arrow
                                        >
                                          <TextField
                                            size="small"
                                            id="outlined-basic"
                                            placeholder={injectIntlTranslation(
                                              intl,
                                              "dxfNameField",
                                              constants.dxfNameField
                                            )}
                                            label={injectIntlTranslation(
                                              intl,
                                              "dxfNameField",
                                              constants.dxfNameField
                                            )}
                                            variant="outlined"
                                            value={injectIntlTranslation(
                                              intl,
                                              field.dxfName,
                                              field.dxfName
                                            )}
                                            onChange={handleFieldChange(
                                              index,
                                              "dxfName"
                                            )}
                                            style={{ width: "100%" }}
                                            InputProps={{
                                              style: { fontWeight: 700 },
                                            }}
                                          />
                                        </Tooltip>

                                        <div
                                          item
                                          className={classes.deleteBtn}
                                          draggable={false}
                                          onDragStart={(e) => {
                                            e.stopPropagation();
                                            return null;
                                          }}
                                          style={{ padding: "6px" }}
                                        >
                                          <DeleteIcon
                                            color="disabled"
                                            fontSize="small"
                                            onClick={() =>
                                              handleDeleteField(field)
                                            }
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
              
              {/* Fixed Footer with Plus and Save Buttons */}
              <div className={classes.blockInfoFooter}>
                <Grid item xs={12} justify="center">
                  <div
                    style={{
                      padding: "5px 10px 5px 10px",
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                  >
                    <AddIcon onClick={handleNewField} />
                  </div>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  justify="flex-end"
                  style={{ marginTop: "2px" }}
                >
                  <CustomButton
                    id="Save-Btn"
                    name={injectIntlTranslation(intl, "Save", "Save")}
                    color="primary"
                    showGradient={true}
                    fullWidth
                    variant="contained"
                    onClick={onSave}
                    disabled={isDisable}
                  >
                    {injectIntlTranslation(intl, "Save", "Save")}
                  </CustomButton>
                </Grid>
              </div>
            </div>
          </div>
        </div>
        <DMDeleteDialog
          open={!!unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={injectIntlTranslation(
            intl,
            "unsaveWarningTitle",
            constants.unsaveWarningTitle
          )}
          contentText={injectIntlTranslation(
            intl,
            "unsavedChangesWarningText",
            constants.unsavedChangesWarningText
          )}
          discardText={injectIntlTranslation(
            intl,
            "dontSaveBtnLabel",
            constants.dontSaveBtnLabel
          )}
          agreeText={injectIntlTranslation(
            intl,
            "saveAndCopyBtnLabel",
            constants.saveAndCopyBtnLabel
          )}
          onProceed={() => {
            onSave(unsaveChangePopup);
          }}
          onDiscard={() => {
            CopySequenceModelAPICall(unsaveChangePopup);
          }}
        />
      </div>
    </ClickAwayListener>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  miscState: state.misc,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getModels: () => dispatch(modelAction.getModels()),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
    deleteRepText: (requestPayload) =>
      dispatch(modelAction.deleteRepText(requestPayload)),
    createRepText: (requestPayload) =>
      dispatch(modelAction.createRepText(requestPayload)),
    updateRepText: (requestPayload) =>
      dispatch(modelAction.updateRepText(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddDynamicFields)
);
